import { gql } from '@apollo/client'
export default gql`
  query GetCountries {
    country {
      id
      name
      isocode
    }
  }
`
